import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import { message } from 'hljd'
import AddMaterial from '@common/AddMaterial'
import Style from './index.module.less'
import Item from './Item'

@observer
export default class extends Component {
  constructor() {
    super()
    this.state = {
      caseList: []
    }
  }

  handleModalOk = list => {
    let { caseList } = this.props
    if (list.length > 8) {
      message.warning('最多选择8个案例')
      return
    }

    caseList.forEach(item => {
      if (list.findIndex(val => val.id === item.id) !== -1) {
        item.checked = true
      } else {
        item.checked = false
      }
    })

    this.props.saveCase(caseList)
  }

  onChange = AddMaterial.checkItem

  checkImg = checked => {
    return (
      <img
        className={Style.isCheck}
        height={24}
        width={24}
        src={
          checked
            ? 'https://qnm.hunliji.com/o_1daofbem7vse18r18ilrst10sc9.png'
            : 'https://qnm.hunliji.com/o_1daofga7k5br1noo1f2v1alv1egie.png'
        }
      />
    )
  }

  render() {
    const { closeCaseModal, caseModalStatus, caseList } = this.props

    const { handleModalOk } = this
    const checks = caseList.filter(c => c.checked).map(c => c.id)
    //console.log(checks)
    return (
      <AddMaterial
        title={
          <p>
            <span style={{ fontSize: 14, fontWeight: 'bold' }}>选择案例</span>
          </p>
        }
        width={800}
        Item={Item}
        list={toJS(caseList)}
        visibility={caseModalStatus}
        onOk={handleModalOk}
        onCancel={closeCaseModal}
        checkList={checks}
        wrapStyle={{ margin: '20px 10px 0' }}
        emptyEle={
          <div style={{ textAlign: 'center' }}>
            <img
              className={Style.emptyImg}
              src="https://qnm.hunliji.com/o_1da6he8b91poa1orv1a1le1gsk39.jpg"
            />
            <div>还没有案例哦，快去上传案例吧~</div>
          </div>
        }
        checkedIcon={this.checkImg}
      />
    )
  }
}
